import { CheckCircle2, Circle, Clock } from "lucide-react";

// Customer-facing 4-step flow. "pending" and "assigned" both map to the
// "scheduled" step so driver assignment is not surfaced to the customer.
const STEPS = [
  { id: "scheduled", label: "Delivery Scheduled", backend: ["pending", "assigned"] },
  { id: "picked_up", label: "Picked Up", backend: ["picked_up"] },
  { id: "in_transit", label: "In Transit", backend: ["in_transit"] },
  { id: "delivered", label: "Delivered", backend: ["delivered"] },
];

const statusToStepIdx = (status) => STEPS.findIndex((s) => s.backend.includes(status));

export default function ShipmentTimeline({ shipment }) {
  if (!shipment) return null;
  const currentIdx = statusToStepIdx(shipment.status);
  const cancelled = shipment.status === "cancelled";

  return (
    <div className="space-y-0" data-testid="shipment-timeline">
      {STEPS.map((step, idx) => {
        const event = (shipment.history || []).find((h) => step.backend.includes(h.status));
        const reached = !cancelled && idx <= currentIdx;
        const isCurrent = !cancelled && idx === currentIdx;
        return (
          <div key={step.id} className="flex gap-4 relative">
            <div className="flex flex-col items-center">
              <div className={`w-6 h-6 flex items-center justify-center shrink-0 ${reached ? "" : "opacity-40"}`}>
                {reached ? (
                  <CheckCircle2 className={`w-5 h-5 ${isCurrent ? "text-brand-green" : "text-brand-success"}`} fill={isCurrent ? "#00D26A" : "transparent"} />
                ) : (
                  <Circle className="w-5 h-5 text-muted-foreground" />
                )}
              </div>
              {idx < STEPS.length - 1 && (
                <div className={`w-[2px] flex-1 min-h-[36px] ${idx < currentIdx ? "bg-brand-success" : "bg-border"}`} />
              )}
            </div>
            <div className="pb-6 flex-1">
              <div className={`font-display uppercase tracking-tight text-base ${reached ? "text-foreground" : "text-muted-foreground"}`}>
                {step.label}
              </div>
              {event && (
                <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground flex items-center gap-2 mt-1">
                  <Clock className="w-3 h-3" />
                  {new Date(event.at).toLocaleString()}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
